"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformPrice = exports.transformAnalyticsData = exports.transformAnalyticsBasketData = exports.removeCurrencySymbol = exports.formatBasketUpdateData = exports.formatBasketProductData = exports.formatBasketData = void 0;
var _productHelpers = require("./../productHelpers");
var _analyticsHelpers = require("./analyticsHelpers");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var formatBasketUpdateData = exports.formatBasketUpdateData = function formatBasketUpdateData(_ref) {
  var _ref$skuAdded = _ref.skuAdded,
    skuAdded = _ref$skuAdded === void 0 ? {} : _ref$skuAdded,
    productId = _ref.productId;
  var _skuAdded$prices = skuAdded.prices,
    _skuAdded$prices2 = _skuAdded$prices === void 0 ? {} : _skuAdded$prices,
    now = _skuAdded$prices2.now;
  return {
    quantity: 1,
    itemPrice: Number(now),
    productId: productId,
    productSku: skuAdded.id,
    services: []
  };
};
var formatBasketProductData = exports.formatBasketProductData = function formatBasketProductData(_ref2) {
  var _ref2$skuAdded = _ref2.skuAdded,
    skuAdded = _ref2$skuAdded === void 0 ? {} : _ref2$skuAdded,
    productId = _ref2.productId,
    _ref2$extraData = _ref2.extraData,
    extraData = _ref2$extraData === void 0 ? {} : _ref2$extraData;
  var _skuAdded$prices3 = skuAdded.prices,
    _skuAdded$prices4 = _skuAdded$prices3 === void 0 ? {} : _skuAdded$prices3,
    now = _skuAdded$prices4.now;
  return _objectSpread(_objectSpread({}, extraData), {}, {
    itemPrice: now.toString(),
    productId: productId,
    qty: '1',
    services: [],
    sku: skuAdded.id
  });
};
var formatBasketData = exports.formatBasketData = function formatBasketData(_ref3) {
  var _ref3$skuAdded = _ref3.skuAdded,
    skuAdded = _ref3$skuAdded === void 0 ? {} : _ref3$skuAdded,
    productId = _ref3.productId;
  var basketItem = formatBasketProductData({
    skuAdded: skuAdded,
    productId: productId
  });
  var _ref4 = window.jlData || {},
    _ref4$basket = _ref4.basket,
    basket = _ref4$basket === void 0 ? {} : _ref4$basket;
  var _basket$product = basket.product,
    product = _basket$product === void 0 ? [] : _basket$product;
  product.push(basketItem);
  var subTotal = product.reduce(function (previous, current) {
    return previous + Number(current.itemPrice);
  }, 0).toFixed(2).toString();
  return {
    product: product,
    subTotal: subTotal
  };
};
var transformAnalyticsBasketData = exports.transformAnalyticsBasketData = function transformAnalyticsBasketData(_ref5) {
  var skuAdded = _ref5.skuAdded,
    productId = _ref5.productId;
  return {
    data: {
      basketUpdate: formatBasketUpdateData({
        skuAdded: skuAdded,
        productId: productId
      }),
      basket: formatBasketData({
        skuAdded: skuAdded,
        productId: productId
      })
    }
  };
};
var removeCurrencySymbol = exports.removeCurrencySymbol = function removeCurrencySymbol(price) {
  return price.replace('£', '');
};
var transformPrice = exports.transformPrice = function transformPrice(price) {
  if (!price) {
    return '';
  }
  if (typeof price === 'string') {
    return removeCurrencySymbol(price);
  }
  if (price.to) {
    return price.to === price.from ? removeCurrencySymbol(price.to) : "".concat(removeCurrencySymbol(price.from), " - ").concat(removeCurrencySymbol(price.to));
  }
};
var transformAnalyticsData = exports.transformAnalyticsData = function transformAnalyticsData(product) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var brandInformation = product.brandInformation,
    _product$breadcrumbs = product.breadcrumbs,
    breadcrumbs = _product$breadcrumbs === void 0 ? [] : _product$breadcrumbs,
    defaultSku = product.defaultSku,
    _product$deliveryInfo = product.deliveryInformation,
    deliveryInformation = _product$deliveryInfo === void 0 ? [] : _product$deliveryInfo,
    emailMeWhenBackInStock = product.emailMeWhenBackInStock,
    id = product.id,
    _product$prices = product.prices,
    prices = _product$prices === void 0 ? {} : _product$prices,
    _product$reviewSummar = product.reviewSummary,
    reviewSummary = _product$reviewSummar === void 0 ? {} : _product$reviewSummar,
    _product$skus = product.skus,
    skus = _product$skus === void 0 ? [] : _product$skus,
    selectedColour = product.selectedColour,
    selectedSize = product.selectedSize,
    _product$sizes = product.sizes,
    sizes = _product$sizes === void 0 ? [] : _product$sizes;
  var _ref6 = reviewSummary || {},
    averageRating = _ref6.rating,
    binCount = _ref6.binCount;
  var colour = selectedColour || (0, _productHelpers.getDefaultColour)({
    skus: skus,
    defaultSku: defaultSku
  });
  var productSize = selectedSize || (0, _productHelpers.getProductSize)(colour, sizes);
  var hasSizeOptions = (0, _productHelpers.hasOptions)(product, 'sizes');
  var hasColourOptions = (0, _productHelpers.hasOptions)(product, 'colours');
  var selectedSku = (0, _productHelpers.determineSelectedSku)(product, hasSizeOptions, hasColourOptions, productSize, colour);
  var displayedSku = selectedSku ? selectedSku.id : defaultSku;
  return {
    data: {
      quickView: _objectSpread(_objectSpread({}, extraData), {}, {
        pageType: 'quickview product',
        pageName: (0, _analyticsHelpers.getPageName)(breadcrumbs, id),
        productId: id,
        brand: brandInformation ? brandInformation.name.toLowerCase() : '',
        breadCrumb: (0, _analyticsHelpers.convertBreadcrumbs)(breadcrumbs),
        colour: colour ? colour.toLowerCase() : '',
        deliveryOptions: (0, _analyticsHelpers.extractDeliveryOptions)(deliveryInformation),
        displayedSku: displayedSku,
        emwbisFormEnabled: emailMeWhenBackInStock,
        numberOfAvailableProductSkus: skus.filter(function (sku) {
          return sku.stockLevel > 0;
        }).length,
        numberOfProductSkus: skus.length,
        outOfStockProductSkus: (0, _analyticsHelpers.getOutOfStockSkus)(skus),
        price: transformPrice(prices.current),
        productViewType: 'quickview product',
        reviews: averageRating ? {
          averageRating: averageRating,
          totalNumber: (0, _productHelpers.stripParentheses)(binCount)
        } : null,
        services: null,
        size: productSize || ''
      })
    }
  };
};